if (!customElements.get('two-column-tabs')) {
  class TwoColumnTabs extends HTMLElement {
    constructor () {
      super()
      this.tabs = this.querySelectorAll('.two-column-cta__tab')
      this.panels = this.querySelectorAll('.two-column-cta__column')
      this.handleTabClick = this.handleTabClick.bind(this)
    }

    connectedCallback () {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', this.handleTabClick)
      })
    }

    disconnectedCallback () {
      this.tabs.forEach(tab => {
        tab.removeEventListener('click', this.handleTabClick)
      })
    }

    handleTabClick (event) {
      const tab = event.target.classList.contains('two-column-cta__tab') ? event.target : event.target.closest('.two-column-cta__tab')
      const panel = document.getElementById(tab.getAttribute('aria-controls'))

      // Handle Tabs
      this.tabs.forEach(tab => {
        tab.setAttribute('aria-selected', 'false')
      })
      tab.setAttribute('aria-selected', 'true')

      // Handle Panels
      this.panels.forEach(panel => {
        panel.classList.remove('active')
      })
      panel.classList.add('active')
    }
  }

  customElements.define('two-column-tabs', TwoColumnTabs)
}